import React, { lazy } from 'react';
import MainContainer from 'components/MainContainer';
import MainLayout from 'layouts/MainLayout';
import ForeignAgentKrik from 'components/ForeignAgentKrik';

const ServiceContent = lazy(() => import('content/Service'));

const Newsletters = ({ type }) => (
	<MainLayout>
		<ForeignAgentKrik />
		<MainContainer>
			<ServiceContent type={type} />
		</MainContainer>
	</MainLayout>
);
export default Newsletters;
